/**
 * The 5 / 15 / 30 / 60 chips beside a watching cadence field (SPEC § Settings modal → Schedule).
 *
 * Cadences are free integer minutes, 1-1440 — a **setting**, not a code constant, so an agent can
 * retune one through #69 without a deploy. These four are a typing shortcut and nothing else: the
 * field stays a plain number input, and a chip only writes into the draft the same string the user
 * could have typed. That is input state, not arithmetic on a DTO field (§12.5).
 */

import { cx } from '../../components';

/** Presets, in minutes, in the order the SPEC lists them. */
export const CADENCE_QUICK_PICKS = [5, 15, 30, 60] as const;

export type CadenceQuickPicksProps = {
  /** The field's current raw value, so the matching chip can read as selected. */
  value: string;
  onPick: (minutes: string) => void;
  disabled?: boolean;
  /** Names the group for assistive tech, e.g. "Cadence presets". */
  ariaLabel: string;
};

export function CadenceQuickPicks({ value, onPick, disabled, ariaLabel }: CadenceQuickPicksProps) {
  return (
    <div className="watch-picks" role="group" aria-label={ariaLabel}>
      {CADENCE_QUICK_PICKS.map((minutes) => {
        const raw = String(minutes);
        return (
          <button
            key={minutes}
            type="button"
            className={cx('tag watch-pick', value.trim() === raw && 'watch-pick--on')}
            aria-pressed={value.trim() === raw}
            disabled={disabled}
            onClick={() => onPick(raw)}
          >
            {minutes} min
          </button>
        );
      })}
    </div>
  );
}

export default CadenceQuickPicks;
